module.exports = __webpack_public_path__ + "img/3.b90d7f5d.png";